var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.98014 14.6666C11.662 14.6666 14.6468 11.6818 14.6468 7.99992C14.6468 4.31802 11.662 1.33325 7.98014 1.33325C4.29824 1.33325 1.31348 4.31802 1.31348 7.99992C1.31348 11.6818 4.29824 14.6666 7.98014 14.6666Z",
    fill: "#4E4B66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14634 10.0201V5.98011C7.14634 5.66011 7.01301 5.53345 6.67301 5.53345H5.80634C5.46634 5.53345 5.33301 5.66011 5.33301 5.98011V10.0201C5.33301 10.3401 5.46634 10.4668 5.80634 10.4668H6.66634C7.01301 10.4668 7.14634 10.3401 7.14634 10.0201Z",
    fill: "#4E4B66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 10.0201V5.98011C10.667 5.66011 10.5337 5.53345 10.1937 5.53345H9.33368C8.99368 5.53345 8.86035 5.66011 8.86035 5.98011V10.0201C8.86035 10.3401 8.99368 10.4668 9.33368 10.4668H10.1937C10.5337 10.4668 10.667 10.3401 10.667 10.0201Z",
    fill: "#4E4B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseUpload);
export default __webpack_public_path__ + "static/media/PauseUpload.fdf6e6bd7dfa60e59b2b2e369324ef96.svg";
export { ForwardRef as ReactComponent };